import { render, staticRenderFns } from "./Serie.vue?vue&type=template&id=383aebc0"
import script from "./Serie.vue?vue&type=script&lang=js"
export * from "./Serie.vue?vue&type=script&lang=js"
import style0 from "./Serie.vue?vue&type=style&index=0&id=383aebc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports